import { UserAction } from "@brookbush/types";

import {
	ClipboardListIcon,
	GraduationCapIcon,
	type LucideIcon,
	StarIcon,
} from "lucide-react";

export interface WelcomeModalOption {
	title: string;
	key: string;
	icon: LucideIcon;
	href: string;
	color: string;
	bg: string;
}

export const WELCOME_MODAL_OPTIONS: WelcomeModalOption[] = [
	{
		title: "Create an Account",
		key: "membership",
		icon: StarIcon,
		href: "#",
		color: "text-yellow-500",
		bg: "bg-yellow-100 dark:bg-yellow-900/30",
	},
	{
		title: "Get Your Custom Certification or CE Roadmap",
		key: "learning_plan",
		icon: ClipboardListIcon,
		href: "#",
		color: "text-emerald-500",
		bg: "bg-emerald-100 dark:bg-emerald-900/30",
	},
	{
		title: "NCCA-accredited CPT Exam Study Plan",
		key: "cpt_study_plan",
		icon: GraduationCapIcon,
		href: "/certifications/cpt-certification-study-plan",
		color: "text-sky-500",
		bg: "bg-sky-100 dark:bg-sky-900/30",
	},
];

/**
 * Signed-in accounts skip the guest welcome timer. An explicit
 * `isWelcomeModalShown: false` flag is the local reset that opens it anyway.
 */
export function shouldOpenWelcomeModalForAccount(options: {
	isSignedIn: boolean;
	isWelcomeModalShown?: boolean;
	userAction: UserAction | null;
}): boolean {
	return (
		options.isSignedIn &&
		options.isWelcomeModalShown === false &&
		options.userAction !== UserAction.WELCOME
	);
}
